import {Menu, MenuItem} from "navigation-common/types/navigation-types";

export class FrontendUtils {
    BRIGHT_COLOR_TRESHOLD = 130;

    isMobile(): boolean {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }

    sessionIsExpired() {
        console.log("session is expired. Releoading the client");
        // @ts-ignore
        AP.navigator.reload();
    }

    /**
     * Returns true if the perceived brightness of the given color is high enough that a dark text is readable on it.
     * @param hexColor
     */
    isBright(hexColor?: string): boolean {
        if (!hexColor) {
            return true;
        }
        const color = parseInt(hexColor.substring(1), 16),
            R = (color >> 16),
            G = (color >> 8 & 0x00FF),
            B = (color & 0x0000FF),
            brightness = Math.round((R * 299 + G * 587 + B * 114) / 1000);
        return brightness > this.BRIGHT_COLOR_TRESHOLD;
    };

    hexToRgbColor(hex: string): string {
        // copied from https://stackoverflow.com/a/21648508/6291294
        let colorArray: string[];
        if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
            colorArray = hex.substring(1).split('');
            if (colorArray.length == 3) {
                colorArray = [colorArray[0], colorArray[0], colorArray[1], colorArray[1], colorArray[2], colorArray[2]];
            }
            let colorsAsNumber: number = Number('0x' + colorArray.join(''));

            return [(colorsAsNumber >> 16) & 255, (colorsAsNumber >> 8) & 255, colorsAsNumber & 255].join(',');
        }

        return "0, 0, 0";
    }

    preloadImages(menu: Menu) {
        menu.menuItems.forEach((menuItem: MenuItem) => {
            if (menuItem.imageUrl) {
                const img = new Image();
                img.src = menuItem.imageUrl;
            }

            menuItem.subMenuItems?.forEach((subMenuItem: MenuItem) => {
                if (subMenuItem.imageUrl) {
                    const img = new Image();
                    img.src = subMenuItem.imageUrl;
                }
            });
        });
    }
}

export const frontendService: FrontendUtils = new FrontendUtils();
